// extracted by mini-css-extract-plugin
export var container = "footer-module--container--HXu2X";
export var title = "footer-module--title--2l0q1";
export var link = "footer-module--link--3CZtx";
export var ending1 = "footer-module--ending1--3U5oF";
export var ending2 = "footer-module--ending2--2aCvg";
export var more = "footer-module--more--3rpPB";
export var cookieButton = "footer-module--cookieButton--28bYR";